import axios from 'axios';

export const authService = {
    /** Events */

    getEventsService: (resourceId, params) => axios.get(`/clinical/event/${resourceId}`, { auth: true, params: { ...params } }),

    getEventsGraphDataService: (params) => axios.get(`/clinical/event/graph-info`, { auth: true, params: params }),

    createEventService: (body) => axios.post(`/clinical/event`, body, { auth: true }),

    editEventService: (id, body) => axios.patch(`/clinical/event/${id}`, body, { auth: true }),

    deleteEventService: (id) => axios.delete(`/clinical/event/${id}`, { auth: true }),

    getEventGraphService: (id) => axios.get(`/clinical/event/graph-info`, { auth: true }),

    /** End */
};
